import ApiService from './api.service';

const TributeVideoService = token => {
    const api = ApiService.createApiInstance(token, { enableBugsnag: true });

    return {
        createTributeVideoByEvent(eventId, data) {
            if (!eventId || eventId <= 0) {
                throw new Error('Invalid value for eventId');
            }

            return api.post(`/TributeVideo/event/${eventId}`, data);
        },
        createTributeVideoByService(serviceSlug, data) {
            if (!serviceSlug) {
                throw new Error('Invalid value for serviceSlug');
            }

            return api.post(`/TributeVideo/service/${serviceSlug}`, data);
        },
        getTributeVideoByEvent(eventId) {
            return api.get(`/TributeVideo/get-tribute-by-event/${eventId}`);
        },
        getTributeVideoByServiceSlug(serviceSlug) {
            return api.get(`/TributeVideo/get-tribute-by-service/${serviceSlug}`);
        },
        submitRender(tributeVideoId) {
            let data = {
                tributeId: tributeVideoId,
            };

            return api.post(`/TributeVideoRender/`, data);
        },
        adminUpdateTribute(id, dto) {
            return api.put(`/TributeVideo/tribute-admin-update/${id}`, dto);
        },
        getSharedUploadInfo(slug) {
            return api.get(`/TributeVideo/shared-upload-info/${slug}`);
        },
        getTributeToken(slug, pin, sessionId = null) {
            return api.get(`/TributeVideo/tribute-token/${slug}/${pin}?sessionId=${sessionId}`);
        },
        invite(tributeId, data) {
            return api.post(`/TributeVideoPhoto/tribute-invite/${tributeId}`, data);
        },
        shareFinalVideo(tributeId, data) {
            return api.post(`/TributeVideo/video-share/${tributeId}`, data);
        },
        refreshTokenAndAllLinks(tributeId) {
            return api.post(`TributeVideo/refresh-token-and-all-links/${tributeId}`);
        },
        getCurrentServiceToken(tributeId) {
            return api.get(`TributeVideo/current-service-tribute-token/${tributeId}`);
        },
        generatePreviewJson(tributeId) {
            return api.post(`/TributeVideoRender/generate-tribute-video-json/${tributeId}`);
        },
        forceRefreshTributeJson(tributeId) {
            return api.post(`/TributeVideoRender/force-refresh-tribute-video-json/${tributeId}`);
        },
        getPreviewJsonWithRenderSettings(tributeId, data) {
            return api.post(`/TributeVideoRender/get-tribute-json-with-render-settings/${tributeId}`, data);
        },
        getTributRender(tributeId, copyrightSafe = false) {
            return api.get(`/TributeVideoRender/${tributeId}?copyrightSafe=${copyrightSafe}`);
        },
        getSettings(tributeId) {
            return api.get(`/TributeVideo/settings/${tributeId}`);
        },
        getRenderSettings(tributeId) {
            return api.get(`/TributeVideo/render-settings/${tributeId}`);
        },
        updateSettings(tributeId, data) {
            return api.post(`/TributeVideo/settings/${tributeId}`, data);
        },
        updateRenderSettings(tributeId, data) {
            return api.post(`/TributeVideo/render-settings/${tributeId}`, data);
        },
        updateDeadline(tributeId, data) {
            return api.post(`/TributeVideo/deadline/${tributeId}`, data);
        },
        getChangelogEvents(tributeId, pageSize = 24, continuationToken = null) {
            let params = {
                continuationToken: continuationToken,
                pageSize: pageSize,
            };

            return api.get(`/TributeVideo/changelog/${tributeId}`, { params });
        },
        checkOutOfSync(tributeId) {
            return api.get(`/TributeVideoRender/check-out-of-sync/${tributeId}`);
        },
        undoAllChangesSinceRender(tributeId) {
            return api.post(`/TributeVideo/changelog/undo-all-since-render/${tributeId}`);
        },
        adminGetTributeRender(renderId) {
            return api.get(`/TributeVideoRender/admin-edit/${renderId}`);
        },
        adminUpdateTributeRender(renderId, data) {
            return api.put(`/TributeVideoRender/admin-edit/${renderId}`, data);
        },
        setTributeSubmissionsOpen(tributeId, bool) {
            return api.post(`/TributeVideo/submissions-open/${tributeId}`, {
                submissionsOpen: bool,
            });
        },
        setWebSlideshowSeconds(tributeId, float) {
            return api.post(`/TributeVideo/web-slideshow/duration/${tributeId}`, {
                webSlideshowSlideSeconds: float,
            });
        },
        triggerCreatomateRenderImport(tributeRenderId) {
            return api.post(`/TributeVideoRender/creatomate-tribute-render-import/${tributeRenderId}`);
        },
        createTributeUserFromSession(serviceSlug, uploadPin, sessionId, name, relationship) {
            if (!sessionId) throw new Error('SessionId required');
            if (!tributeId) throw new Error('TributeId required');

            return api.post(`/TributeVideo/users/create-from-session/${serviceSlug}/${uploadPin}`, {
                name,
                relationship,
                serviceSlug,
                sessionId,
            });
        },
        getUserCurrent(sessionId) {
            return api.get(`/TributeVideo/users/current/${sessionId}`);
        },
        getUserAdmin(sessionId) {
            return api.get(`/TributeVideo/users/admin/${sessionId}`);
        },
        updateUser(serviceSlug, uploadPin, sessionId, name, relationship) {
            return api.post(`/TributeVideo/users/edit/${serviceSlug}/${uploadPin}/${sessionId}`, {
                name,
                relationship,
                serviceSlug,
            });
        },
        getTributeUsers(tributeId, pageSize = 24, pageNumber = 0, sortBy = 'Id', sortAsc = false) {
            if (!tributeId) throw new Error('TributeId required');
            let params = {
                tributeId,
                pageSize,
                pageNumber,
                sortBy,
                sortAsc,
            };
            return api.get(`/TributeVideo/users/admin`, { params });
        },
        toggleOutroSlate(tributeId, currentValue) {
            return api.post(`/TributeVideo/toggle-outro-slate/${tributeId}?value=${!currentValue}`);
        },
        toggleOutroBrandedVideo(tributeId, currentValue) {
            return api.post(`/TributeVideo/toggle-outro-branded-video/${tributeId}?value=${!currentValue}`);
        },
        replaceOutroSlateWithThemeDuplicate(tributeId, currentValue) {
            return api.post(`/TributeVideo/toggle-replace-outro-slate-with-theme/${tributeId}?value=${!currentValue}`);
        },
        getRenderSasUrl(tributeId, renderId) {
            return api.get(`/TributeVideo/download-render/${tributeId}/${renderId}`);
        },
    };
};

export default TributeVideoService;
